import axios from "axios"

export default function deleteGift({ id }) {
    return new Promise((resolve, reject) => {
        axios.delete(`/campaign/api/admin/items/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}